import React, { useMemo } from "react";

import { Divider, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { ISubCategory } from "store/types";

import { useForm } from ".";
import { Characteristic } from "./Characteristic";

interface Props {
  categories: ISubCategory[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  subCategoryId: number | null;
  disabled?: boolean;
  viewOnly?: boolean;
}

export const AssetReport: React.FC<Props> = ({ categories, onChange, subCategoryId, disabled, viewOnly = false }) => {
  const { getCharacteristics } = useForm();

  const characteristics = getCharacteristics({
    category_name: "Asset Report",
    is_deleted: false,
    subcategory_ids: [subCategoryId || 0]
  }).filter((c) => c.subcategory_ids?.length);

  const list = useMemo(() => {
    if (!subCategoryId) {
      return <Typography>Please select an asset type</Typography>;
    }

    if (!characteristics.length) {
      return <Typography>No parameters assigned to this asset type</Typography>;
    }
    return (
      <Stack>
        <Typography>Parameters</Typography>
        <Divider sx={{ borderColor: "#DBE8F5", mb: "20px" }} />
        <Stack gap="20px">
          {characteristics.map((item) => (
            <Characteristic
              key={item.id}
              {...item}
              viewOnly={viewOnly}
              is_deleted={false}
              hideEyeIcon
              subcategoryId={subCategoryId}
            />
          ))}
        </Stack>
      </Stack>
    );
  }, [subCategoryId, characteristics]);

  return (
    <Stack>
      <TextField
        disabled={disabled || viewOnly}
        sx={{ mb: "20px", input: { padding: "12.5px 14px" } }}
        select
        fullWidth
        label="Asset type"
        value={subCategoryId}
        onChange={onChange}
      >
        {categories.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
      {list}
    </Stack>
  );
};
